import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaHeart, FaCartShopping } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import horizontalLogo from '../assets/horizontal.png';
import { DISPLAY, MONO, Container, Mail, Phone, Instagram, Facebook, TikTok, WhatsApp } from './home/ui';

// [texto, ruta]; '#' = página que todavía no existe.
const EMPRESA = [['Sobre Bigotes', '#'], ['Sucursales', '/sucursales'], ['Blog', '#'], ['Trabaja con nosotros', '#'], ['Mayoreo', '#']];
const AYUDA = [['Rastrea tu pedido', '/rastrear'], ['Envíos y entregas', '/sucursales'], ['Cambios y devoluciones', '#'], ['Términos y condiciones', '#'], ['Aviso de privacidad', '#'], ['Contacto', '/dashboard/chat']];
const PAGOS = ['VISA', 'MC', 'AMEX', 'EFECTIVO', 'TRANSFERENCIA'];
const SOCIALS = [['Instagram', Instagram], ['Facebook', Facebook], ['TikTok', TikTok], ['WhatsApp', WhatsApp]];

const FootCol = ({ title, children }) => (
    <div>
        <h4 className='text-white text-[16px] font-bold mb-[14px] tracking-[-.005em]' style={DISPLAY}>{title}</h4>
        <ul className='flex flex-col gap-2'>{children}</ul>
    </div>
);

const Footer = () => {
    const navigate = useNavigate();
    const { userInfo } = useSelector(state => state.auth);
    const { card_product_count, wishlist_count } = useSelector(state => state.card);
    const { categorys } = useSelector(state => state.home);
    const tienda = categorys.filter(c => c && c.name).slice(0, 6);

    return (
        <footer className='bg-[#0b1530] text-white/65 text-[14px] pt-14 pb-8'>
            <Container>
                <div className='grid gap-9 mb-9 grid-cols-[1.3fr_1fr_1fr_1.1fr] md-lg:grid-cols-2 sm:grid-cols-1'>

                    <div>
                        <img src={horizontalLogo} alt='Señor Bigotes' className='h-[42px] w-auto bg-white px-3 py-2 rounded-[10px] mb-[14px]' />
                        <p className='mb-[14px] max-w-[300px] leading-[1.6]'>
                            Pet shop de barrio con alma digital. Comida, accesorios y cuidados premium para perros, gatos y la familia entera.
                        </p>
                        <div className='flex flex-col gap-2 text-[13px]'>
                            <a href='mailto:hola@senorbigotes.com' className='inline-flex items-center gap-2 text-white/75 hover:text-white transition-colors'>
                                <Mail className='w-[14px] h-[14px] text-[#0891b2]' />hola@senorbigotes.com
                            </a>
                            <a href='tel:5551234567' className='inline-flex items-center gap-2 text-white/75 hover:text-white transition-colors'>
                                <Phone className='w-[14px] h-[14px] text-[#0891b2]' />55 1234 5678
                            </a>
                        </div>
                        <div className='flex gap-2 mt-[14px]'>
                            {SOCIALS.map(([label, Icon]) => (
                                <a key={label} href='#' aria-label={label} className='w-[34px] h-[34px] rounded-full bg-white/[.08] grid place-items-center hover:bg-[#0891b2] hover:text-white hover:-translate-y-[2px] transition-all'>
                                    <Icon className='w-[14px] h-[14px]' />
                                </a>
                            ))}
                        </div>
                    </div>

                    <FootCol title='Tienda'>
                        {tienda.map(c => (
                            <li key={c._id}><Link to={`/products?category=${c.name}`} className='hover:text-white transition-colors'>{c.name}</Link></li>
                        ))}
                        <li><Link to='/shops' className='hover:text-white transition-colors'>Ver toda la tienda</Link></li>
                    </FootCol>

                    <FootCol title='Empresa'>
                        {EMPRESA.map(([item, to]) => (
                            <li key={item}><Link to={to} className='hover:text-white transition-colors'>{item}</Link></li>
                        ))}
                    </FootCol>

                    <div>
                        <FootCol title='Ayuda'>
                            {AYUDA.map(([item, to]) => (
                                <li key={item}><Link to={to} className='hover:text-white transition-colors'>{item}</Link></li>
                            ))}
                        </FootCol>
                        <div className='flex flex-wrap gap-2 mt-[14px]'>
                            {PAGOS.map(p => (
                                <span key={p} className='bg-white/[.08] border border-white/10 px-[10px] py-[6px] rounded-[8px] text-[10.5px] font-semibold text-white/80 tracking-[.04em]' style={MONO}>{p}</span>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='pt-[22px] border-t border-white/[.08] flex justify-between items-center flex-wrap gap-[10px] text-[12.5px] text-white/45'>
                    <span>© {new Date().getFullYear()} Señor Bigotes Pet Shop · Hecho con 🐾 en Guatemala</span>
                    <span>Todos los derechos reservados</span>
                </div>
            </Container>

            {/* Botones flotantes en móvil */}
            <div className='hidden fixed md-lg:block w-[50px] h-[110px] bottom-3 right-2 bg-white rounded-full p-2 z-50 shadow-[0_6px_18px_-6px_rgba(15,23,42,.25)]'>
                <div className='w-full h-full flex gap-3 flex-col justify-center items-center'>
                    <div onClick={() => navigate(userInfo ? '/card' : '/login')} className='relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]'>
                        <FaCartShopping className='text-xl text-[#0891b2]' />
                        {card_product_count !== 0 && (
                            <div className='w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] text-xs font-bold'>
                                {card_product_count}
                            </div>
                        )}
                    </div>
                    <div onClick={() => navigate(userInfo ? '/dashboard/my-wishlist' : '/login')} className='relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]'>
                        <FaHeart className='text-xl text-[#0891b2]' />
                        {wishlist_count !== 0 && (
                            <div className='w-[20px] h-[20px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px] text-xs font-bold'>
                                {wishlist_count}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
